<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isNewEditVisible"
  (nzVisibleChange)="onIsNewEditVisibleChange($event)"
  [nzTitle]="isEdit ? 'Edit Methodology' : 'Add New Methodology'"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="null"
  [nzCancelText]="null"
>
  <ng-container *nzModalContent>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="title">Title</nz-form-label>
        <nz-form-control nzErrorTip="Title required.">
          <div class="horizontal">
            <input nz-input formControlName="title" id="title" [placeholder]="'Your title'" />
            <a
              class="horizontal link-button"
              nz-button
              nzType="default"
              nzSize="default"
              (click)="onGenerateDescriptionClick()"
            >
              <span nz-icon style="font-size: 16px" class="material-symbols-rounded">auto_awesome</span>
              <span>Generate Description & Rubrics</span>
            </a>
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="description">Description</nz-form-label>
        <nz-form-control nzErrorTip="Methodology description required.">
          <textarea
            nz-input
            formControlName="description"
            rows="5"
            id="description"
            [placeholder]="'Your methodology.'"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      @for (control of listOfControl; track control; let i = $index) {
        <nz-form-item>
          @if (i === 0) {
            <nz-form-label class="full-width horizontal seperate" nzRequired [nzFor]="control.controlInstance">
              <div class="full-width horizontal seperate">
                <div>Rubrics</div>
                <a nz-button nzType="default" nzSize="small" (click)="onGenerateRubricsClick()">
                  <span nz-icon style="font-size: 16px" class="material-symbols-rounded">auto_awesome</span>
                  Generate Rubrics
                </a>
              </div>
            </nz-form-label>
          }
          <nz-form-control nzErrorTip="Please add a rubric.">
            <div class="horizontal">
              <input
                class="passenger-input"
                nz-input
                placeholder="Rubric"
                [attr.id]="control.id"
                [formControlName]="control.controlInstance"
              />

              <button
                nz-button
                nzType="default"
                nzSize="small"
                [disabled]="i === 0 && listOfControl.length === 1"
                (click)="removeField(control, $event)"
              >
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
              </button>
            </div>
          </nz-form-control>
        </nz-form-item>
      }

      <nz-form-item class="add-rubric-btn">
        <nz-form-control>
          <button nz-button nzType="dashed" nzSize="small" (click)="addField($event)">
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
            <span>Add Rubric</span>
          </button>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <button nz-button [nzType]="'primary'" class="submit-button">{{ isEdit ? 'Save' : 'Create' }}</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
